<button class="btn btn-link" (click)="downloadFile()">
  <i class="fa-solid fa-download fa-lg text-primary"></i>
  <!--<label><b>{{"DCO.ClientFileConfiguration_DownloadFile" | translate}}</b></label>-->
</button>